import { getTypedState } from 'ducks/hooks'
import { concatSeparator } from 'helpers'
import { Job } from 'ducks/types'
import { JobType } from './types'

export const getJob = () => (): JobType | null => {
  const { job } = getTypedState()
  return job ?? null
}

export const getJobAddress = (): string => {
  const { job } = getTypedState()
  const { state, city, line_1: street1, line1 } = (job !== null && (job as Job)?.properties?.address) || {}
  const address = concatSeparator(street1 || line1 as string, concatSeparator(city || '', state || '', ', '), ' - ')
  return address || 'No address'
}
